export enum IMAGE_VARIANT {
    STANDARD = 'standard',
    RETINA = 'retina',
    MOBILE = 'mobile',
    ORIGINAL = 'original',
    WITHOUT = 'without',
}
const imageVariantsMaxSize = {
    45: IMAGE_VARIANT.STANDARD,
    90: IMAGE_VARIANT.RETINA,
    128: IMAGE_VARIANT.MOBILE,
    [Number.MAX_VALUE]: IMAGE_VARIANT.ORIGINAL,
};
const getVariant = (querySize: number) =>
    function (variantMaxSize: string) {
        return querySize <= parseInt(variantMaxSize, 10);
    };

export function getImageVariantBySize(querySize: number): IMAGE_VARIANT {
    const variant =
        Object.keys(imageVariantsMaxSize).find(getVariant(querySize)) ?? Number.MAX_VALUE;

    return imageVariantsMaxSize[variant as keyof typeof imageVariantsMaxSize];
}
